import { concat, pick } from "ramda";

// Redux Prefix
const prefix = concat("BILLING:");

const SET_BILLING_TYPE = prefix("SET_BILLING_TYPE");
const SET_OCCURRENCES = prefix("SET_OCCURENCES");
const SET_PAYMENT_INTERVAL = prefix("SET_PAYMENT_INTERVAL");

const INITIAL_STATE = {
  billingType: "",
  interval: "",
  occurences: 0,
};

// Actions
export const setBillingType = (billingType) => ({
  type: SET_BILLING_TYPE,
  payload: {
    billingType,
  },
});

export const setPaymentInterval = (interval) => ({
  type: types.SET_PAYMENT_INTERVAL,
  payload: {
    interval,
  },
});

export const setOccurences = (occurrences) => ({
  type: types.SET_OCCURRENCES,
  payload: {
    occurrences,
  },
});

// Reducer
export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_BILLING_TYPE:
      return {
        ...state,
        billingType: action.payload.billingType,
      };
    case SET_PAYMENT_INTERVAL:
      return {
        ...state,
        interval: action.payload.interval,
      };
    case SET_OCCURRENCES:
      return {
        ...state,
        occurrences: action.payload.occurrences,
      };
    default:
      return state;
  }
}
